// extracted by mini-css-extract-plugin
module.exports = {"screen":"Layout-module--screen--otGo_","wrapper":"Layout-module--wrapper--3Ss1f"};